import React from 'react'
import LayoutMain from '../layouts/LayoutMain'
import MyBlock from '../UI/block/MyBlock'
import SubmenuPacks from '../pack/submenu/SubmenuPacks'
import MyBlockHeader from '../UI/block/MyBlockHeader'
import AddGoodInPackForm from './AddGoodInPackForm'

const AddGoodInPack = () => {
  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuPacks />
		</MyBlock>
        <MyBlockHeader
            header={'Додавання товару в партію'}
            // isBack={true}
            // options={
            //     <FactoryOneOptions 
            //         factoryId={id}
            //     />
            // }
        />
        {/* <MyBlock>
            <BoxOneOptions 
                boxId={boxId}
            />
        </MyBlock> */}
		<MyBlock>
            <AddGoodInPackForm />
        	{/* <BoxOneList 
				boxId={boxId}
			/> */}
		</MyBlock>
    </LayoutMain>
  )
}

export default AddGoodInPack